<template>
   <div class="grid mt-1"> 
     
      <div class="col-12">

        <InputText type="text" v-model="note" placeholder="Inserisci note aggiuntive per il commercialista..." class="inputfield w-full" />
        <div class="text-center p-info">
          <small>Il movimento sarà gestito dal commercialista.</small>
        </div>
        
        <div class="mt-3 text-right">
            <Button 
            @click="associa" 
            label="Associa movimento" 
            class="p-button-outlined" 
            :disabled="!note" 
            :class="!note ? 'p-button-secondary' : ' p-button-primary'" 
            />
        </div>

      </div>
   </div>


</template>

<script>
import { ref, getCurrentInstance } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-service'

export default {
  emits:['movement-regularized'],
  components: {
  },
  props: {
    detail: {
      type: Object,
      required: true
    },
  },
  setup(props, {emit}) {
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const estrattoConto = ref(props.detail)
    const note = ref('')


    const associa = () => {
      let nota = `${note.value} - ${estrattoConto.value.descrizione}`
        service.associateToCommercialista(estrattoConto.value, nota).then((res)=> {
          if (res) {
            emit('movement-regularized',{id: estrattoConto.value.id})
          }
        }) 
    }
    
    return {
      estrattoConto,
      note,
      associa,
    }
  },
}
</script>
<style scoped>
.p-info {
  margin-top: 10px;
  background-color: #e3f2fd;
  padding: 16px;
  border-radius: 8px;
  color: #2ca9f3;
}
</style>
